import React from 'react';
import NotifyBlock from '../../../../../components/NotifyBlock'

import 'moment/locale/ru';

const filters = () => [
	// {
	// 	label: "Прочитан",
	// 	display: item => !item.prochitano,
	// 	name: "prochitano",
	// 	type: "bool",
	// 	sort: true,
	// 	filter: true,
	// 	sorted: "DESC"
	// },
	{
		label: "Дата статуса",
		display: item => item.UpdatedAt,
		name: "dataPoslednegoIzmeneniya",
		type: "date",
		sort: true,
		filter: true
	},
	{
		label: "Тип участия",
		display: item => item.tekst01TipUchastiyaVFederatsii,
		name: "tekst01TipUchastiyaVFederatsii",
		type: "string",
		sort: true,
		filter: true
	},
	{
		label: "Регион",
		display: item => item.tekst11RO,
		name: "tekst11RO",
		type: "string",
		sort: true,
		filter: true
	},
	{
		label: "Текущий статус",
		display: item => item.tekst04StatusPoPriemu,
		name: "tekst04StatusPoPriemu",
		type: "string",
		sort: true,
		filter: true
	},
	{
		label: "Инициатор",
		display: item => item.tekst02Initsiator,
		name: "tekst02Initsiator",
		type: "string",
		sort: true,
		filter: true
	},
	{
		label: "Орган принятия решения",
		display: item => item.tekst12OgranPrinyatiyaResheniya,
		name: "tekst12OgranPrinyatiyaResheniya",
		type: "string",
		sort: true,
		filter: true
	},
	{
		label: "Вопрос повестки дня",
		display: item => item.tekst13VPD,
		name: "tekst13VPD",
		type: "string",
		sort: true,
		filter: true
	},
	{
		label: "Дата инициирования",
		display: item => item.tekst03DataInitsiirovaniya,
		name: "tekst03DataInitsiirovaniya",
		type: "date",
		sort: true,
		filter: true
	},
	{
		label: "Дата реального назначения",
		display: item => item.tekst05DataPriema,
		name: "tekst05DataPriema",
		type: "date",
		sort: true,
		filter: true
	},
	{
		label: "Дата начала работы",
		display: item => item.tekst15DataNachalaRaboti,
		name: "tekst15DataNachalaRaboti",
		type: "date",
		sort: true,
		filter: true
	},
	{
		label: "Инициатор исключения",
		display: item => item.tekst07InitsiatorPoisklyucheniyu,
		name: "tekst07InitsiatorPoisklyucheniyu",
		type: "string",
		sort: true,
		filter: true
	},
	{
		label: "Дата заявки на исключение",
		display: item => item.tekst06DataPodachiNaIsklyuchenie,
		name: "tekst06DataPodachiNaIsklyuchenie",
		type: "date",
		sort: true,
		filter: true
	},
	{
		label: "Статус по исключению",
		display: item => item.tekst08StatusPoIsklyucheniyu,
		name: "tekst08StatusPoIsklyucheniyu",
		type: "string",
		sort: true,
		filter: true
	},
	{
		label: "Дата исключения",
		display: item => item.tekst09DataIsklyucheniya,
		name: "tekst09DataIsklyucheniya",
		type: "date",
		sort: true,
		filter: true
	}
];


export default function Notifications(props) {
	return (
		<>
			<NotifyBlock {...props} filters={filters} uuid="a5747ab3ed1e"/>
		</>
	);
}
